<template>
  <div>
    <el-row class="query">
      <el-select v-model="queryObj.teamId" placeholder="选择车队">
        <el-option v-for="team in teams" :key="team.id" :label="team.name" :value="team.id">
        </el-option>
      </el-select>
      &nbsp;
      <el-select v-model="queryObj.bankId" placeholder="所有题库">
        <el-option
          v-for="bankInfo in exbanks"
          :key="bankInfo.id"
          :label="bankInfo.name"
          :value="bankInfo.id"
        >
        </el-option>
      </el-select>
      &nbsp;
      <el-button @click.native="query">查询</el-button>
    </el-row>
    <el-table :data="learns" style="width: 100%">
      <el-table-column prop="name" label="姓名" width="180"> </el-table-column>
      <el-table-column sortable prop="no" label="班号" width="180"> </el-table-column>
      <el-table-column sortable prop="uptime" label="最后学习时间"> </el-table-column>
      <el-table-column sortable prop="wrNums" label="错题数"> </el-table-column>
      <el-table-column sortable prop="colNum" label="收藏题数"> </el-table-column>
      <el-table-column sortable prop="undones" label="未做题目"> </el-table-column>
      <el-table-column sortable prop="wRate" label="错题率"> </el-table-column>
      <el-table-column sortable prop="lRate" label="学习进度"> </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  name: "TrainStat",
  data() {
    return {
      queryObj: { bankId: "", teamId: "" },
      exbanks: [],
      teams: [],
      learns: []
    };
  },
  mounted() {
    this.initPage();
  },
  methods: {
    initPage() {
      this.$http.post("/admin/train/stat/initexbank", {}).then((res) => {
        this.exbanks = res.data.exbanks || [];
        this.exbanks.splice(0, 0, { id: "", name: "所有题库" });
        this.teams = res.data.teams || [];
        this.queryObj.teamId = this.teams[0].id;
      });
    },
    query() {
      let url = "/admin/train/stat/exbank";
      this.$http.post(url, this.queryObj).then((res) => {
        this.learns = res.data || [];
      });
    }
  }
};
</script>

<style scoped>
.query {
  margin-top: 24px;
  margin-bottom: 24px;
  text-align: right;
}
</style>
